import { pushDataLayerEvent } from "./metricManagementUtil"

export function linkDatalayer({ label }) {
  pushDataLayerEvent({
    event: "Interacciones - Articulos",
    category: "link",
    action: "click",
    label,
    Location: window.location.href,
  })
}

export function nexArticleDatalayer({ label, category }) {
  pushDataLayerEvent({
    event: "Interacciones - Articulos",
    category: category || "anterior/siguiente",
    action: "click",
    label: label,
    Location: window.location.href,
  })
}
